import React, { useEffect, useRef } from 'react';
import { DownloadSimple, Trash, X } from '@phosphor-icons/react';

const actionButtonClasses = 'inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50';

const FileExplorerSelectionBar = ({
  totalVisible,
  selectedCount,
  allVisibleSelected,
  onToggleSelectAll,
  onClear,
  onDelete,
  onDownload,
  deleting,
  downloading
}) => {
  const selectAllRef = useRef(null);

  // Estado "indeterminado" (guión, no tilde) cuando hay selección parcial:
  // solo se puede setear vía DOM, no existe como atributo/prop de <input>.
  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = selectedCount > 0 && !allVisibleSelected;
    }
  }, [selectedCount, allVisibleSelected]);

  if (totalVisible === 0 && selectedCount === 0) return null;

  const busy = deleting || downloading;

  return (
    <div className="mx-4 mt-2 mb-1 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber/30 bg-amber/12 px-4 py-2.5 shadow-md shadow-black/20">
      <label className="flex items-center gap-2.5 text-sm text-content cursor-pointer select-none">
        <input
          ref={selectAllRef}
          type="checkbox"
          checked={totalVisible > 0 && allVisibleSelected}
          onChange={onToggleSelectAll}
          disabled={totalVisible === 0}
          className="h-4 w-4 rounded border-line bg-surface text-amber focus:ring-amber focus:ring-offset-0 cursor-pointer disabled:cursor-not-allowed"
        />
        {selectedCount > 0 ? (
          <span className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center rounded-full bg-amber px-2 py-0.5 text-xs font-semibold text-on-amber min-w-[1.5rem]">
              {selectedCount}
            </span>
            seleccionado{selectedCount === 1 ? '' : 's'}
          </span>
        ) : (
          'Seleccionar todo'
        )}
      </label>

      {selectedCount > 0 && (
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onDownload}
            disabled={busy}
            className={`${actionButtonClasses} bg-surface-2 text-content hover:bg-line`}
          >
            <DownloadSimple size={16} weight="bold" />
            {downloading ? 'Preparando descarga...' : 'Descargar'}
          </button>
          <button
            type="button"
            onClick={onDelete}
            disabled={busy}
            className={`${actionButtonClasses} bg-error hover:bg-error/85 text-white`}
          >
            <Trash size={16} weight="bold" />
            {deleting ? 'Eliminando...' : 'Eliminar'}
          </button>
          <div className="w-px h-6 bg-line" aria-hidden="true" />
          <button
            type="button"
            onClick={onClear}
            disabled={busy}
            title="Salir de selección"
            className="inline-flex items-center justify-center w-8 h-8 rounded-md text-content-muted hover:text-content hover:bg-surface-2 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          >
            <X size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default FileExplorerSelectionBar;
